import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./baseQueryWithReauth";

export const rewardApi = createApi({
  reducerPath: "rewardApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getBalance: builder.query({
      query: (clientCode) => `api/r/balance/${clientCode}`,
    }),
    getTransactions: builder.query({
      query: (clientCode) => `api/r/balance-history/${clientCode}`,
    }),
    getDiscountOffer: builder.query({
      query: ({ clientCode, offerId }) =>
        `api/r/balance/${clientCode}/discount-offer/${offerId}`,
    }),
    getMorePoints: builder.query({
      query: () =>
        `api/r/event-type`,
    }),
    purchaseDiscountOffer: builder.mutation({
      query: ({ clientCode, offerId, ...body }) => ({
        url: `api/r/balance/${clientCode}/discount-offer/${offerId}`,
        method: "POST",
        body,
      }),
    }),
    addRewardPoints: builder.mutation({
      query: (body) => ({
        url: `api/r/event`,
        method: "POST",
        body,
      }),
    }),
    getAccountStatus: builder.query({
      query: () => `api/account-type-status/`,
    }),
  }),
});

export const {
  useGetBalanceQuery,
  useGetTransactionsQuery,
  useGetDiscountOfferQuery,
  usePurchaseDiscountOfferMutation,
  useAddRewardPointsMutation,
  useLazyGetBalanceQuery,
  useGetAccountStatusQuery,
  useGetMorePointsQuery,
} = rewardApi;
